module.exports = __webpack_public_path__ + "static/gallery_07-thumb-d39e00d74af629bb99033dc076c38f97.jpg";